export const activeBoardImage = elements => (elements || []).find(el => el.shape === 'board_image' && !el.hidden);
export const visibleBoardElements = elements => activeBoardImage(elements) ? [activeBoardImage(elements)] : (elements || []).filter(el => el.shape !== 'board_image');

// Decode and re-encode local raster files: no URLs, SVG scripts or EXIF location.
export async function readBoardImage(file) {
  if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw new Error('Elige una imagen JPG, PNG o WebP.');
  if (file.size > 10 * 1024 * 1024) throw new Error('La imagen no puede superar 10 MB.');
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const image = new Image(); image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('No se pudo leer la imagen. Prueba con otro archivo.')); image.src = url;
    });
    if (!img.naturalWidth || img.naturalWidth * img.naturalHeight > 25000000) throw new Error('La imagen es demasiado grande. Reduce su resolución.');
    let scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
    for (let attempt = 0; attempt < 5; attempt++, scale *= 0.8) {
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
      const ctx = canvas.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL('image/jpeg', 0.86);
      if (image.length <= 1200000) return image;
    }
    throw new Error('La imagen sigue siendo demasiado pesada. Usa una versión más pequeña.');
  } finally { URL.revokeObjectURL(url); }
}
